import { resolveLinkProps, isResolvedInternal } from '@lib/resolveLinkProps';
import type { ResolvedLink } from '@lib/resolveLinkProps';
import useSelector from '../redux/typedHooks';

export const useResolveLink = (url?: string | null, blank?: boolean): ResolvedLink => {
  const baseUrl = useSelector((state) => state.application.baseUrl);
  const linkProps = resolveLinkProps({ url, baseUrl, blank });

  if (isResolvedInternal(linkProps)) {
    return { isInternal: true, linkProps };
  }

  return { isInternal: false, linkProps };
};
